import { render, staticRenderFns } from "./QuickStartRoute.vue?vue&type=template&id=a43dc6c4&scoped=true"
import script from "./QuickStartRoute.vue?vue&type=script&lang=ts"
export * from "./QuickStartRoute.vue?vue&type=script&lang=ts"
import style0 from "./QuickStartRoute.vue?vue&type=style&index=0&id=a43dc6c4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43dc6c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a43dc6c4')) {
      api.createRecord('a43dc6c4', component.options)
    } else {
      api.reload('a43dc6c4', component.options)
    }
    module.hot.accept("./QuickStartRoute.vue?vue&type=template&id=a43dc6c4&scoped=true", function () {
      api.rerender('a43dc6c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/QuickStartRoute.vue"
export default component.exports